import { IModalService } from '../interfaces/modal-service.interface';
import { BehaviorSubject, element as $ } from '@contorion/core';
import { requestService } from '@contorion/core/services/request.service';

const REGEX_HASH_CHECK = /^#/;
const SELECTOR_DEFAULT = '#staticPageContent';

class ModalService implements IModalService {
    headline: BehaviorSubject<string> = new BehaviorSubject(null);
    content: BehaviorSubject<string> = new BehaviorSubject(null);
    type: BehaviorSubject<string> = new BehaviorSubject(null);
    isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
    isSmall: BehaviorSubject<boolean> = new BehaviorSubject(false);
    wrapperClass: BehaviorSubject<string> = new BehaviorSubject(null);

    public getContent(href: string, selector: string = SELECTOR_DEFAULT): void {
        this.isLoading.next(true);

        if (REGEX_HASH_CHECK.test(href)) {
            this.getContentFromElement($(href));
        } else {
            this.getContentFromPage(href, selector);
        }
    }

    protected getContentFromElement(element: Element): void {
        if (!element) {
            return;
        }

        this.content.next(element.innerHTML);

        this.isLoading.next(false);
    }

    protected async getContentFromPage(url: string, selector: string): Promise<void> {
        const content = await requestService.get(url)
            .then((response: Response) => response.text());

        let virtualDom = document.createElement('div');
        virtualDom.innerHTML = content;

        let contentElement = $(selector, virtualDom);

        if(!contentElement || !contentElement.innerHTML || contentElement.innerHTML.trim().length === 0) {
            this.isLoading.next(false);
            window.location.href = url;
            return;
        }

        this.content.next(contentElement.outerHTML);

        virtualDom = null;
        contentElement = null;
        this.isLoading.next(false);
    }
}

export const modalService = new ModalService();
